'use strict';

(function () {
    'use strict';

    AppController.$inject = ['$rootScope', 'localStorageService'];
    angular.module('app').controller('AppController', AppController);

    function AppController($rootScope, localStorageService) {
        'ngInject';

        var vm = this;

        activate();

        ////////////////

        function activate() {
            vm.authUser = localStorageService.get('authUser');

            var lang = angular.element(document).find('html').attr('lang');
            if (lang == 'el') {
                vm.breadcrumbs = [{ label: 'Αρχική', url: 'https://smartcity.heraklion.gr/el/home/' }];
            } else {
                vm.breadcrumbs = [{ label: 'Home', url: 'https://smartcity.heraklion.gr/en/home/' }];
            }

            vm.appURI = angular.element(document).find('body').attr('data-viz-app-uri');
            vm.pageURL = angular.element(document).find('body').attr('data-viz-page-url');

            /* NVD3-tooltips bug fix */
            angular.element(document).on('scroll', function () {
                angular.element('.nvtooltip.xy-tooltip').css('opacity', 0);
            });
        }
    }
})();